import {
  LayoutDashboard,
  Settings,
  Users,
  Building,
  GraduationCap,
  MessageSquare,
  Calendar,
  CalendarDays,
  BarChart3,
  FolderOpen
} from 'lucide-react'

export const educatorMenuData = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    icon: LayoutDashboard
  },
  {
    name: 'Classes',
    link: '/classes',
    icon: GraduationCap
  },
  {
    name: 'Calendar',
    link: '/calendar',
    icon: CalendarDays
  },
  {
    name: 'Inbox',
    link: '/inbox',
    icon: MessageSquare
  },
  // Library (teaching materials) sits directly under Inbox when enabled — the
  // institute asked for it there, by that name. Hidden again for now; the page,
  // storage and in-meeting panel are all built, so re-enabling is uncommenting
  // this and the MaterialsPanel block in custom-control-bar.tsx.
  // {
  //   name: 'Library',
  //   link: '/materials',
  //   icon: FolderOpen
  // },
  {
    name: 'Attendance',
    link: '/attendance',
    icon: Calendar
  },
  {
    name: 'Settings',
    link: '/settings',
    icon: Settings
  }
]

export const learnerMenuData = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    icon: LayoutDashboard
  },
  {
    name: 'Classes',
    link: '/classes',
    icon: GraduationCap
  },
  {
    name: 'Calendar',
    link: '/calendar',
    icon: CalendarDays
  },
  {
    name: 'Inbox',
    link: '/inbox',
    icon: MessageSquare
  },
  {
    name: 'Attendance',
    link: '/attendance',
    icon: Calendar
  }
]

export const adminMenuData = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    icon: LayoutDashboard
  },
  {
    name: 'Calendar',
    link: '/calendar',
    icon: CalendarDays
  },
  {
    name: 'Attendance',
    link: '/attendance',
    icon: BarChart3
  }
]
